App.filter('apiDate', function () {
    return function (_date) {
        if (!angular.isDefined(_date)) return null;
        if (angular.isDate(_date)) {
            var mm = _date.getMonth() + 1; // getMonth() is zero-based
            var dd = _date.getDate();

            return [_date.getFullYear(),
                (mm > 9 ? '' : '0') + mm,
                (dd > 9 ? '' : '0') + dd
            ].join('-');
        }
        return _date.substring(0, 10);
    }
});
